import { ShippingBox, ShippingBoxesResponse, ShippingBoxSaveResponse, ShippingQuoteResponse } from '@services/shipping/interfaces/shipping.interfaces';
import { Mock } from '@shared/interfaces/mock.interface';

export const MOCKED_SHIPPING_PRICE = 4500;

export const MOCKED_SHIPPING_ESTIMATED_DAYS = 6;

export const MOCKED_PRIORITY_SHIPPING_PRICE = 12900;

export const MOCKED_PRIORITY_SHIPPING_ESTIMATED_DAYS = 3;

export const SHIPPING_QUOTE_RESPONSE: ShippingQuoteResponse = {
  currency: 'CLP',
  packagesCount: 1,
  options: [
    { serviceLevel: 'basic', label: 'Básico', serviceName: 'BASICO', shippingPrice: MOCKED_SHIPPING_PRICE, estimatedDays: MOCKED_SHIPPING_ESTIMATED_DAYS },
    {
      serviceLevel: 'priority',
      label: 'Prioritario',
      serviceName: 'PRIORITARIO',
      shippingPrice: MOCKED_PRIORITY_SHIPPING_PRICE,
      estimatedDays: MOCKED_PRIORITY_SHIPPING_ESTIMATED_DAYS,
    },
  ],
};

export const SHIPPING_QUOTE_MOCKS: Mock<ShippingQuoteResponse> = {
  success: [{ response: SHIPPING_QUOTE_RESPONSE }],
  failures: [
    {
      response: {
        statusCode: 422,
        message: 'Chilexpress no tiene cobertura en la comuna seleccionada.',
        reasonCode: 'COMMUNE_WITHOUT_COVERAGE',
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any,
  ],
};

export const SHIPPING_BOXES_RESPONSE: ShippingBoxesResponse = {
  boxes: [
    { id: 'box-s', code: 'S', label: 'Chica', lengthCm: 20, widthCm: 15, heightCm: 10, maxWeightGrams: 2000, isActive: true },
    { id: 'box-m', code: 'M', label: 'Mediana', lengthCm: 30, widthCm: 25, heightCm: 15, maxWeightGrams: 5000, isActive: true },
    { id: 'box-l', code: 'L', label: 'Grande', lengthCm: 40, widthCm: 30, heightCm: 25, maxWeightGrams: 10000, isActive: true },
  ],
  fillFactor: 0.75,
};

export const SHIPPING_BOXES_MOCKS: Mock<ShippingBoxesResponse> = {
  success: [{ response: SHIPPING_BOXES_RESPONSE }],
  failures: [],
};

export const SHIPPING_BOX_SAVE_RESPONSE: ShippingBoxSaveResponse = {
  box: SHIPPING_BOXES_RESPONSE.boxes[1] as ShippingBox,
  productsWithoutBox: [],
};

export const SHIPPING_BOX_SAVE_MOCKS: Mock<ShippingBoxSaveResponse> = {
  success: [{ response: SHIPPING_BOX_SAVE_RESPONSE }],
  failures: [],
};
